import React from 'react';

import Header from './partials/Header';
    import Banner from './landing/Banner';
    import HassleFreeSkincare from './landing/HassleFreeSkincare';
    import SkincareJourney from './landing/SkincareJourney';
    import SkinHealthFactor from './landing/SkinHealthFactor';
    import BiggestPainPoint from './landing/BiggestPainPoint';
    import GoodSkinFeel from './landing/GoodSkinFeel';
    import ScreenCareEnd from './landing/ScreenCareEnd';
    import HowItWork from './landing/HowItWork';
import Footer from './partials/Footer';

function Landing() {
  return (
    <div className="landing">
        <Header/>
            <Banner/>
            <HassleFreeSkincare/>
            <SkincareJourney/>
            <SkinHealthFactor/>
            <BiggestPainPoint/>
            <GoodSkinFeel/>
            <ScreenCareEnd/>
            <HowItWork/>
        <Footer/>
    </div>
  );
}

export default Landing;
